import { useState } from 'react'
import APIError from '../errors/APIError'

export function useErrorHandler(err?: Error | APIError | null) {
  const [error, setError] = useState(err)
  if (err) throw err
  if (error) throw error
  return [setError]
}
